module.exports = __webpack_public_path__ + "img/league.84552a68.png";